<template>
    <div class="fhv-centent" v-loading="loading">
        <h4 class="title-topic">
            <el-button icon="el-icon-back" v-on:click="$emit('back')"></el-button>
            Reserved IP Address Settings
        </h4>
        <el-form label-width="180px" label-position="left"   class="fhv-form dhcpReservedEnable"
        :disabled="$G_DEVICE_CFG.isReadOnly">
            <el-form-item label="DHCP Reserved :" > 
                <el-switch v-model="dhcpReservedEnable" @change="dhcpReservedSwitch"></el-switch>
            </el-form-item>
        </el-form>
      
        <div v-if="dhcpReservedEnable">
        <hr>
        <el-table :data="tableData" border class="fhv-table" size="mini">
            <el-table-column
            type="index"
            width="50">
            </el-table-column>
            <el-table-column label="MAC Address" prop="mac"></el-table-column>
            <el-table-column label="IP Address" prop="ip"></el-table-column>
            <el-table-column label="Action" width="100">
            <template slot-scope="scope">
                <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
            </template>
            </el-table-column>
        </el-table>
        <div class="fh-btn-contain">
            <el-button type="primary" @click="dialogFormVisible = true" size="mini" :disabled="$G_DEVICE_CFG.isReadOnly">Add</el-button>
            <el-button type="primary" @click="refresh" size="mini">Refresh</el-button>
        </div>
        </div>
        <el-dialog title="Add Reserved IP Address" :visible.sync="dialogFormVisible" >
            <el-form 
            :model="dhcpReservedForm"  
            label-width="120px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            :rules="formCheck" 
            ref="dhcpReservedForm"
            >
                <el-form-item label="MAC Address :" prop="mac">
                    <el-input v-model="dhcpReservedForm.mac"></el-input>
                </el-form-item>
                <el-form-item label="IP Address :" prop="ip">
                    <el-input v-model="dhcpReservedForm.ip"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="confirm">Confirm</el-button>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading:false,
            dialogFormVisible:false,
            tableData:[],
            dhcpReservedEnable:false,
            dhcpReservedForm:{
                ip:'',
                mac:''
            },
            formCheck:{
                ip:[
                    { required: true, message: 'ip cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isIP(value,4))
                                callback(new Error('ip error! e.g. 192.168.1.1'));
                            else
                                callback()
                        },
                        trigger: 'blur'
                    }
                ],
                mac:[
                    { required: true, message: 'mac cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isMACAddress(value))
                                callback(new Error('mac error! e.g. 00:ca:cb:ff:dd:22'));
                            else
                                callback()
                        },
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    beforeMount(){
        this.getData()
    },
    methods:{
        getData(){
            this.loading = true
            axios
            .post("/boafrm/fhLanIPv4",{CmdType:"GET_DHCP_RESERVED"})
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                     this.tableData = response.data.dhcpReserved.lists
                     this.dhcpReservedEnable = response.data.dhcpReserved.dhcpReservedEnable
                }
                else
                    this.$message.error(`GET data failed! Error:${response.data.errMsg}`)
            })
        },
        addData(){
            this.loading = true
            axios
            .post("/boafrm/fhLanIPv4",{
                CmdType:"SET_DHCP_RESERVED",
                actionType:"ADD",
                ip:this.dhcpReservedForm.ip,
                mac:this.dhcpReservedForm.mac,
            })
            .then((response)=>{
                setTimeout(()=>{//每次提交数据都延迟3s 方式操作过快到时 请求错误
                    this.loading = false
                    if(response.data.ret === 0)
                    {
                        this.$message.success("Configuration is successful!")
                        this.tableData.push(
                            {
                                ip:this.dhcpReservedForm.ip,
                                mac:this.dhcpReservedForm.mac
                            })
                        this.dhcpReservedForm.ip = ''
                        this.dhcpReservedForm.mac = ''
                    }
                    else
                        this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
                },3000)
            })
        },
        confirm(){
            this.$refs['dhcpReservedForm'].validate((valid) => {
                if (valid) {
                    this.dialogFormVisible = false
                    this.addData()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        refresh(){
            this.getData()
        },
        handleDelete(index, row){
            this.loading = true
            axios
            .post("/boafrm/fhLanIPv4",{
                CmdType:"SET_DHCP_RESERVED",
                actionType:"DEL",
                index:index + 1
            })
            .then((response)=>{
                setTimeout(()=>{//每次提交数据都延迟3s 方式操作过快到时 请求错误
                    this.loading = false
                    if(response.data.ret === 0)
                    {
                        this.$message.success("Configuration is successful!")
                        this.tableData.splice(index,1)
                    }
                    else
                        this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
                },3000)
            })
            
        },
        dhcpReservedSwitch(){
            this.loading = true
            axios
            .post("/boafrm/fhLanIPv4",{
                CmdType:"SET_DHCP_RESERVED",
                actionType:"SWITCH",
                dhcpReservedEnable:this.dhcpReservedEnable
            })
            .then((response)=>{
                setTimeout(()=>{//每次提交数据都延迟3s 方式操作过快到时 请求错误
                    this.loading = false
                    if(response.data.ret === 0)
                        this.$message.success("Configuration is successful!")
                    else
                        this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
                },3000)
                
            })
        }
    }
}
</script>

<style scoped>
.fhv-form{
    margin-left: 15%
}
.dhcpReservedEnable{
    margin-left: 0;
}
@media (max-width: 768px) {
    .fhv-form{
        margin-left: 0;
    }
}
</style>



